
  export default {
    props: {
      color: {
        type: String,
        default: '#191B1E'
      }
    }
  }
